(function($, window, document, undefined) {
  var $win = $(window);
  var $doc = $(document);

  $doc.ready(function() {
    slider($('.list-info'), false, true);
  });

  function slider($slider, dots, arrows) {
    let $slides = $slider;

    if (dots == undefined) {
      dots = false;
    }

    if (arrows == undefined) {
      arrows = false;
    }

    $slides.slick({
      dots: dots,
      arrows: arrows,
      slidesToShow: 6,
      slidesToScroll: 1,
      speed: 500,
      centerMode: false,
      variableWidth: false,
      adaptiveHeight: false,
      fade: false,
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="fas fa-chevron-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="fas fa-chevron-right"></i></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
})(jQuery, window, document);
